import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import { MOCK_TEMPLATES } from '@/mocks/directories'
import { USE_MOCKS } from '@/mocks/fixtures'
import type { DocumentTemplate } from '@/types/domain'

/* What is left of the fixture-backed directory hooks.
 *
 * Clients, participants and transport moved to ./useDirectory in Epic 7 —
 * real endpoints over real tables, with scoping and suppression enforced
 * server-side. Issuing entities and numbering moved to
 * ../../settings/api/useCompanySettings in Stories 1.5 and 1.6.
 *
 * Document templates are the remainder: the reusable not-included and
 * disclaimer blocks (FR-60), which Epic 2 owns because that is where they are
 * used. The path is unchanged but no longer a fixture — Story 2.9 moved
 * GET /settings/templates onto the settings module's real rows.
 */

export function useDocumentTemplates() {
  return useQuery<DocumentTemplate[]>({
    queryKey: ['settings', 'templates'],
    queryFn: async () =>
      USE_MOCKS
        ? MOCK_TEMPLATES
        : (await api.get<{ items: DocumentTemplate[] }>('/settings/templates')).items,
  })
}
